// @ts-strict

import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-deep-link-created-info',
  templateUrl: './deep-link-created-info.component.html',
  styleUrls: ['./deep-link-created-info.component.scss']
})
export class DeepLinkCreatedInfoComponent {
  @Input() selectedConfigurationName: number | string = '';
}
